import {get, post, postJson} from './axios'


const RESOURCE_BASE_PATH = '/smsSendTest'

// 短信测试提交记录
export const getPrecisionJdSuffixList = p => get(`${RESOURCE_BASE_PATH}/records`,p);